import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaGamepad, FaShieldAlt, FaShoppingBag, FaBoxOpen, FaCrown } from "react-icons/fa";
import "./MobileBottomNav.scss";

interface NavItem {
    id: string;
    label: string;
    icon: React.ComponentType<any>;
    path: string;
}

const MobileBottomNav: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const navItems: NavItem[] = [
        { id: "play", label: "Play", icon: FaGamepad, path: "/play" },
        { id: "govip", label: "GoVIP", icon: FaCrown, path: "/go-vip-dashboard" },
        { id: "guilds", label: "Guilds", icon: FaShieldAlt, path: "/guilds" },
        { id: "lootshop", label: "LootShop", icon: FaShoppingBag, path: "/lootshop" },
        { id: "lootboxes", label: "LootBoxes", icon: FaBoxOpen, path: "/devourlootbox" },
    ];

    const handleNavClick = (item: NavItem) => {
        navigate(item.path);
    };

    const isActive = (path: string) => {
    // Exact match for most paths
        if (path === location.pathname) {
            return true;
        }
        // Special case for LootShop (could be redirected)
        if (path === "/lootshop" && location.pathname === "/restaurants/674a30b9b53b4c9f4aee6587") {
            return true;
        }
        // For paths that might have sub-routes
        return location.pathname.startsWith(`${path}/`);
    };

    return (
        <nav className="mobile-bottom-nav">
            {navItems.map((item) => {
                const Icon = item.icon;
                return (
                    <button
                        key={item.id}
                        className={`nav-item ${isActive(item.path) ? "active" : ""}`}
                        onClick={() => handleNavClick(item)}
                        aria-label={item.label}
                        title={item.label}
                    >
                        <Icon className="nav-icon" />
                        {/* Icons only - no labels */}
                    </button>
                );
            })}
        </nav>
    );
};

export default MobileBottomNav;